import { MARK_QUIZ } from './actionTypes'

export const getMarkedQuiz = (data) => {

    return {
        type: MARK_QUIZ,
        payload: data
    }

}